var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.iconT.custom)?_c('v-icon',{attrs:{"color":_vm.color,"size":_vm.size}},[_vm._v("\n  "+_vm._s(_vm.iconT.src)+"\n")]):_c('img',{staticStyle:{"transform":"scale(1.4)"},style:(_vm.filter),attrs:{"src":_vm.iconT.src,"height":"25"}})
}
var staticRenderFns = []

export { render, staticRenderFns }